import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid credit-card" }
const _hoisted_2 = { class: "row" }

import { defineAsyncComponent } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'paymentDetail',
  setup(__props) {

const creditCard = defineAsyncComponent(() => import("@/components/theme/ecommerce/payment/creditCard.vue"))
const debitCard = defineAsyncComponent(() => import("@/components/theme/ecommerce/payment/debitCard.vue"))
const codCard = defineAsyncComponent(() => import("@/components/theme/ecommerce/payment/codCard.vue"))
const emiCard = defineAsyncComponent(() => import("@/components/theme/ecommerce/payment/emiCard.vue"))
const netBanking = defineAsyncComponent(() => import("@/components/theme/ecommerce/payment/netBanking.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Ecommerce",
      title: "Payment Details"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(creditCard)),
        _createVNode(_unref(debitCard)),
        _createVNode(_unref(codCard)),
        _createVNode(_unref(emiCard)),
        _createVNode(_unref(netBanking))
      ])
    ])
  ], 64))
}
}

})